import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { usePermissionDeniedStore } from '../stores/permission-denied.store';
import { ContentThemeProvider } from '../theme/ContentThemeProvider';
import DialogHeader from './common/DialogHeader';
import { DIALOG_ACTIONS_SX, DIALOG_CONTENT_SX } from '../constants/dialog.styles';

/**
 * Global "permission denied" dialog (opened from API 403s and route gates).
 * Mounted at the app root, so it brings the content theme with it.
 */
const PermissionDeniedOverlay: React.FC = () => {
  const { open, message, hide } = usePermissionDeniedStore();

  return (
    <ContentThemeProvider surface={false}>
      <Dialog open={open} onClose={hide} maxWidth="xs" fullWidth aria-labelledby="permission-denied-title">
        <DialogHeader id="permission-denied-title" icon={LockOutlinedIcon} title="Permission denied" onClose={hide} />
        <DialogContent sx={DIALOG_CONTENT_SX}>
          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>
        </DialogContent>
        <DialogActions sx={DIALOG_ACTIONS_SX}>
          <Button variant="contained" onClick={hide} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </ContentThemeProvider>
  );
};

export default PermissionDeniedOverlay;
